/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import {GuidlinesProps} from ".";
import GuidelinesSection from "./GuidelinesSection";
import YesNoButtons from "./YesNoButtons";
import buildingSvg from "assets/images/building.svg";
import dollarDocumentSvg from "assets/images/dollar-document.svg";
import Ul from "./Ul";
import ButtonsContainer from "./ButtonsContainer";
import QuestionTitle from "./QuestionTitle";

export default function OtherGuidelines({onYes, onNo}: GuidlinesProps) {
  return (
    <div
      css={css`
        display: flex;
        gap: 5px;
        flex-direction: column;
      `}
    >
      <QuestionTitle>
        Is this a non-LRO risk that you would like to submit for GL coverage?
      </QuestionTitle>
      <GuidelinesSection title="Non-LRO Risk" svgUrl={buildingSvg}>
        <Ul>
          <li>
            Use this option for risks that do not fit Habitational, Mixed
            Mercantile, SkillPac, Homeowner, or BOP
          </li>
          <li>
            You will need to provide basic insured and property information
          </li>
          <li>
            An Acord application must be uploaded for GL exposure details
          </li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="Process" svgUrl={dollarDocumentSvg}>
        <Ul>
          <li>Basic insured and property info will be sent to Majesco</li>
          <li>
            Underwriters will complete the GL sections in Majesco using the
            uploaded Acord application
          </li>
        </Ul>
      </GuidelinesSection>
      <ButtonsContainer>
        <YesNoButtons onYes={onYes} onNo={onNo} />
      </ButtonsContainer>
    </div>
  );
}
